import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=61445dca&"
import script from "./Campaigns.vue?vue&type=script&lang=js&"
export * from "./Campaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61445dca')) {
      api.createRecord('61445dca', component.options)
    } else {
      api.reload('61445dca', component.options)
    }
    module.hot.accept("./Campaigns.vue?vue&type=template&id=61445dca&", function () {
      api.rerender('61445dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Campaigns.vue"
export default component.exports